import React from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import ThemeControls from "../../Component/AllThemesControl";
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Switch from '@mui/material/Switch';

const  fields =  [
    // { label: "Module Name", key: "applicationcontext", type:'', format:'name' },
    { label: "Application Context", key: "applicationcontext", type:'' },
    { label: "Role", key: "roleId" , type:''},
    { label: "Access", key: "accessPersmission", type:'switch' },
    { label: "Authorize", key: "", type:'' },
    { label: "Delete", key: "", type:'' },
    { label: "Save", key: "" , type:''},
    { label: "Updates", key: "" , type:''}
  ]

  const subFields = [
        // { label: "Module Name", key: "applicationcontext", type:'', format:'name' },
        { label: "Application Context", key: "applicationcontext", type:'' },
        { label: "Role", key: "roleId" , type:''},
        { label: "Access", key: "accessPersmission" , type:'switch'},
        { label: "Authorize", key: "authorizeP", type:'switch' },
        { label: "Delete", key: "deleteP" , type:'switch'},
        { label: "Save", key: "saveP" , type:'switch'},
        { label: "Updates", key: "updatesP" , type:'switch'}
      ]

function Row(props) {
  const [row, setRow] = React.useState(props.row);
  const [open, setOpen] = React.useState(false);
  const { useStyles } = ThemeControls;
  const classes = useStyles();
  const updatePermissions = (id, field, value) => {
    setRow(prevRow => {
      const newRow = { ...prevRow };
      newRow[field] = value;
      return newRow;
    });
  };

  function capitalizeFirstLetter(str) {
    // Check if the input is a non-empty string
    if (typeof str !== 'string' || str.length === 0) {
      return str;
    }
  
    // Capitalize the first letter and concatenate with the rest of the string
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        {props.fields.map((field, index) => (
          field.key?<TableCell key={index} component="th" scope="row">
            {field.type === 'switch' ? <Switch
              checked={row[field.key] === 1}
              disabled={field.key !== 'accessPersmission' && row['accessPersmission'] !== 1}
              onChange={e =>
                updatePermissions(row.id, field?.key, e.target.checked ? 1 : 0)
              }
            /> : field.format === 'name' ? capitalizeFirstLetter(row[field.key]) : row[field.key]}
          </TableCell>:<TableCell></TableCell>
        ))}
        {/* {row?.children && (
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
        )} */}
      </TableRow>
      {row?.children?.length>0&&(
        <TableRow style={{ background: '#e3eefa' }}>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={subFields.length + 1}>
            <Collapse in={row?.accessPersmission===1} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Table size="small" aria-label="sub-table">
                  <TableHead>
                    <TableRow>
                      {subFields.map((field, index) => (
                        <TableCell key={index} align="left" style={{fontWeight: 600}}>{field.label}</TableCell>
                      ))}
                      {/* <TableCell /> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                                      {row?.children.map((row, index) => (
                                          <Row key={index} row={row} fields={row?.isPrent===1?fields:subFields}/>
                                      ))
                                      }
                    {/* <TableRow>
                        {row?.children.map((field, index) => (
                        <TableCell key={index} component="th" scope="row">
                          {getFieldValue(field.key, row)}
                        </TableCell>
                      ))}
                    </TableRow> */}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </React.Fragment>
  );
}

export default function CollapsibleTable({ data }) {
    const { useStyles } = ThemeControls;
    const classes = useStyles();

  return (
    <TableContainer component={Paper} >
        <Table aria-label="collapsible table">
          <TableHead style={{ background: '#fafafa' }}>
            <TableRow>
              {fields.map((field, index) => (
                <TableCell key={index} align="left" style={{fontWeight: 600}}>{field.label}</TableCell>
              ))}
              {/* <TableCell /> */}
            </TableRow>
          </TableHead>
          <TableBody>
              {data.map((row, index) => (
                <Row key={index} row={row} fields={fields}/>
              ))
            }
          </TableBody>
        </Table>
    </TableContainer>
  );
}
